//import applicationLogo from '../../images/Pictionary_Logo Copy 2-Pictionary_Logo@2x.png';
//import applicationLogo from '../../../images/Pictionary_Logo Copy 2-Pictionary_Logo@2x.png';
import { getCdnPath } from '../../../utils/helpers';

const Logo = (props) =>{
    const width = props.width?? process.env.REACT_APP_LOGO_WIDTH;
    const padding = props.padding?? process.env.REACT_APP_LOGO_PADDING;

    return (
        <div style={{width: "100%", maxWidth: "600px", backgroundColor: process.env.REACT_APP_LOGO_BACKGROUND_COLOR, marginLeft: "auto", marginRight: "auto"}}>
            <img src={getCdnPath(props.src)} alt="Application Logo" style={{width: width, height: "auto", padding : padding}}/>
        </div>
    )
}

export default Logo;